import { cva } from 'class-variance-authority';

import { cn } from '@heidi/utils';

/**
 * Base styles for the PageShell.Header component.
 * Uses CSS variable --sidebar-header-height for visual alignment with sidebar header.
 */
export const pageShellHeaderClasses = cn(
  'flex h-[var(--sidebar-header-height)] shrink-0 items-center gap-2 border-b p-2'
);

/**
 * Container for the trigger button, sized to match sidebar header icon.
 * Uses CSS variable --sidebar-header-icon-size for consistent sizing.
 */
export const pageShellHeaderTriggerContainerClasses = cn(
  'flex size-[var(--sidebar-header-icon-size)] shrink-0 items-center justify-center'
);

/**
 * Base styles for the PageShell.Content component.
 * Primary content area with flex layout and padding.
 * Horizontal padding drops when it hosts a PageShell.Container, which owns the
 * gutters; matched as any descendant since app wrappers sit in between.
 */
export const pageShellContentClasses = cn(
  'flex flex-1 flex-col gap-4 p-4 has-[[data-slot=page-shell-container]]:px-0'
);

/**
 * Caps include both gutters (border-box). They assume the `sm:` gutter: a cap
 * only engages on columns wider than 920px, always past `sm`.
 */
export const pageShellContainerVariants = cva('mx-auto w-full min-w-0 px-4 sm:px-8', {
  variants: {
    width: {
      narrow: 'max-w-[calc(920px+4rem)]',
      default: 'max-w-[calc(1280px+4rem)]',
      full: 'max-w-[calc(1664px+4rem)]',
    },
  },
  defaultVariants: {
    width: 'default',
  },
});
